var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "../_snowpack/pkg/react.js";

function SvgIconFlagUk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-flag-uk_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.25 20.25h6c.741 0 1.371-.167 1.895-.459l-7.895-4.709v5.168zm9.622-2.921c.086-.382.13-.785.13-1.204V14.25H18.71l5.161 3.079h.002zM.133 6.659A5.488 5.488 0 000 7.876V9.75h5.312L.132 6.66zM9.75 3.75h-6c-.736 0-1.362.165-1.883.452L9.75 8.905V3.75zM1.891 19.81c.516.279 1.134.44 1.859.44h6v-5.129L1.891 19.81zM0 14.25v1.875c0 .432.046.848.136 1.239l5.22-3.114H0zM22.168 4.22c-.527-.299-1.166-.47-1.918-.47h-6v5.194l7.918-4.723zM24 9.75V7.875c0-.41-.042-.806-.125-1.18l-5.12 3.055H24z",
    fill: "#2E3192"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.755 9.75l5.12-3.055c-.234-1.074-.806-1.963-1.707-2.474L14.25 8.944V3.75h-.75v6.75H24v-.75h-5.245zM0 13.5v.75h5.356l-5.22 3.114c.248 1.07.837 1.95 1.755 2.446l7.859-4.688v5.128h.75V13.5H0zm24 0H13.5v6.75h.75v-5.168l7.895 4.71c.907-.506 1.486-1.39 1.726-2.463l-5.16-3.079H24v-.75zM9.75 3.75v5.155L1.867 4.202C.956 4.705.373 5.588.131 6.66l5.18 3.09H0v.75h10.5V3.75h-.75z",
    fill: "#E6E7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 10.5V3.75h-3v6.75H0v3h10.5v6.75h3V13.5H24v-3H13.5z",
    fill: "#BE1E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.227 9.75L.708 5.262c-.162.24-.291.504-.399.785L6.514 9.75h1.712zm15.432 8.284l-6.305-3.784h-1.746l7.617 4.582c.177-.247.322-.514.434-.797v-.001zm-.89-13.387L14.24 9.75l1.731.001 7.362-4.407a2.544 2.544 0 00-.562-.697zM.68 18.703c.17.257.373.49.604.692l8.49-5.145h-1.71L.68 18.703z",
    fill: "#BE1E2D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-flag-uk_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}

export default SvgIconFlagUk;